const React = require('react')
const { HelmetProvider } = require('react-helmet-async')

exports.wrapRootElement = ({ element }) =>
  React.createElement(HelmetProvider, null, element)
